export const OVERFLOW_MENU_CONTENT_CLASS =
  "w-56 rounded-xl border-border-default/70 bg-bg-deep/95 p-1.5 shadow-xl backdrop-blur-sm";

export const OVERFLOW_MENU_ITEM_CLASS =
  "min-h-10 rounded-md px-3 py-2 text-[14px] font-medium leading-none";

export const OVERFLOW_MENU_CHECKABLE_ITEM_CLASS =
  "min-h-10 rounded-md py-2 pr-3 text-[14px] font-medium leading-none";

export const OVERFLOW_MENU_LABEL_CLASS =
  "px-3 pt-2 pb-1 text-[13px] font-medium text-text-supporting";

export const OVERFLOW_MENU_SEPARATOR_CLASS = "-mx-1 my-1 bg-border-default/70";

export const OVERFLOW_MENU_SHORTCUT_CLASS =
  "ml-auto pl-6 text-[13px] font-medium tracking-normal text-text-supporting";
